import $ from "jquery";
import MicroModal from "micromodal";

const SELECTOR_TRIGGER = '[data-js="jsModalOpen"]';

$(document).on("click", SELECTOR_TRIGGER, function (e) {
  e.preventDefault();
  MicroModal.show($(e.currentTarget).data("modal-id"));
});
